import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

function PropMenu(props) {
  const { filmId, propId } = props.match.params;
  const { prop } = props;
  const invalidIds = ["add", "overview"];

  if (invalidIds.indexOf(propId) > -1) {
    return null;
  }

  return (
    <div className="blade-menu menu">
      <p className="menu-label">Prop</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/props/${propId}/edit`}
            activeClassName="is-active">
            Edit Prop
          </NavLink>
        </li>
        {prop?.canAccessScenes &&
          <li>
            <NavLink
              to={`/films/${filmId}/props/${propId}/scenes/`}
              activeClassName="is-active">
              Scenes
            </NavLink>
          </li>
        }
      </ul>
    </div>
  );
}

function mapStateToProps(state) {
  const { propsState } = state;
  return {
    prop: propsState.prop
  };
}

export default connect(mapStateToProps, {
})(PropMenu);

